// extracted by css-extract-rspack-plugin
export default {"rightTrashIcon--vertical":"src-wab-client-components-sidebar-tabs-ComponentProps-InvalidationEditor-module__rightTrashIcon--vertical-Su2Wwy","rightTrashIconVertical":"src-wab-client-components-sidebar-tabs-ComponentProps-InvalidationEditor-module__rightTrashIcon--vertical-Su2Wwy","rightTrashIcon--horizontal":"src-wab-client-components-sidebar-tabs-ComponentProps-InvalidationEditor-module__rightTrashIcon--horizontal-KKZL9Z","rightTrashIconHorizontal":"src-wab-client-components-sidebar-tabs-ComponentProps-InvalidationEditor-module__rightTrashIcon--horizontal-KKZL9Z"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"rightTrashIcon--vertical\":\"src-wab-client-components-sidebar-tabs-ComponentProps-InvalidationEditor-module__rightTrashIcon--vertical-Su2Wwy\",\"rightTrashIconVertical\":\"src-wab-client-components-sidebar-tabs-ComponentProps-InvalidationEditor-module__rightTrashIcon--vertical-Su2Wwy\",\"rightTrashIcon--horizontal\":\"src-wab-client-components-sidebar-tabs-ComponentProps-InvalidationEditor-module__rightTrashIcon--horizontal-KKZL9Z\",\"rightTrashIconHorizontal\":\"src-wab-client-components-sidebar-tabs-ComponentProps-InvalidationEditor-module__rightTrashIcon--horizontal-KKZL9Z\"}";
        // 1793541996313
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  